import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { ActiveToast } from 'components/layout'
import { AWARD_STATES } from 'constants/enums'

export default class AwardToasts extends Component {
  static propTypes = {
    awardState: PropTypes.object,
  }

  render() {
    const {
      awardState,
    } = this.props

    const showLeaderSignOff = [AWARD_STATES.leader_signoff.id].includes(get(awardState, 'value'))
    const showOfficeSignOff = [AWARD_STATES.office_signoff.id].includes(get(awardState, 'value'))

    return (
      <div>
        <ActiveToast
          text='Awaiting Award Leader Sign-off.'
          intlKey='label.waiting_for_sign_off'
          toShow={showLeaderSignOff}
          noBtn
        />
        <ActiveToast
          text='Awaiting Award Office Sign-off.'
          intlKey='label.waiting_for_office_sign_off'
          toShow={showOfficeSignOff}
          noBtn
        />
      </div>
    )
  }
}
